module.exports = __webpack_public_path__ + "static/img/1020_small.35358c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1020_small.png
// module id = 2LRj
// module chunks = 1